import { render, staticRenderFns } from "./TeamSupervisorForm.vue?vue&type=template&id=1be0211c&scoped=true"
import script from "./TeamSupervisorForm.vue?vue&type=script&lang=js"
export * from "./TeamSupervisorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0211c",
  null
  
)

export default component.exports